import { Badge } from '@masterteam/mt-design-react'
import React from 'react'

export default function ProjectStatus({label, color}) {
  return (
    <Badge
  className="status-badge"
  label={label}
  shape="round"
  title={label}
  backgroundColor={color}
>
{label}
</Badge>
  )
}
